module.exports = __webpack_public_path__ + "img/elazar.91ba104f.png";